import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ERROR_MESSAGE_TYPE } from '../models/enums';

export function sameValueValidator(
  pathToAnotherControl: string,
  nameOfThisControl: string,
  nameOfAnotherControl: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const anotherControl = control?.parent?.get(pathToAnotherControl);

    if (!control?.value || !anotherControl?.value) {
      return null;
    }

    if (control.value !== anotherControl.value) {
      return {
        [ERROR_MESSAGE_TYPE.SAME_VALUE]: {
          nameOfThisControl,
          nameOfAnotherControl,
          valueOfThisControl: control.value,
          valueOfAnotherControl: anotherControl.value,
        },
      };
    }
    return null;
  };
}
